<template>
    <transition v-if="isOldBrowser">
        <div class="old-browser grid grid__custom-1">
            <div class="old-browser--wrapper">
                <div class="old-browser--container grid--container">
                    <h2 class="old-browser--title">
                        {{ title }}
                    </h2>
                    <p class="old-browser--paragraph">
                        <strong>{{ text }}</strong>
                    </p>
                    <div>
                        <h3 class="old-browser--title u-reset__h4">
                            {{ subtitle }}
                        </h3>
                        <div class="old-browser--btn-group">
                            <div class="old-browser--btn-col" v-for="(link, index) in links" :key="index">
                                <a :href="link.path" class="btn old-browser--btn btn__large">
                                    {{ link.label }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { isUndefined } from 'lodash';

    export default {
        props: {
            text: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            subtitle: {
                type: String,
                required: true,
            },
            /* @type ILink */
            links: {
                type: Array,
                required: true,
            },
        },
        computed: {
            isOldBrowser() {
                return isUndefined(window.Proxy);
            },
        },
    };
</script>
